import { render } from "./ShippingStep.vue?vue&type=template&id=64354714&scoped=true"
import script from "./ShippingStep.vue?vue&type=script&lang=js"
export * from "./ShippingStep.vue?vue&type=script&lang=js"

import "./ShippingStep.vue?vue&type=style&index=0&id=64354714&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64354714"]])

export default __exports__